// extracted by mini-css-extract-plugin
module.exports = {"buttons":"Note_buttons__3u6IT"};